module.exports = __webpack_public_path__ + "img/Services_Connecting.7829d2d4.jpg";